import { useMutation } from '@api/hooks'
import AuthApi from '@services/auth.api'
import AuthUtils from '@utils/AuthUtils'

/**
 * Hook to inform the BE the user has logged out
 */
export default function useLogout() {
	return useMutation({
		mutationFn: () => AuthApi.logout(),
		onSuccess: () => {
			AuthUtils.logout()
		},
	})
}
